import React from "react";
import styles from "./WhyChooseUs.module.css";
import { BsShieldCheck } from "react-icons/bs";
import { FaUserTie } from "react-icons/fa";
import { GoBell } from "react-icons/go";

const WhyChooseUs = () => {
    const features = [
        {
            id: 1,
            icon: <BsShieldCheck />,
            title: "End-to-End Compliance",
            description:
                "From registration to annual filings, every compliance need covered under one roof.",
            iconBg: "#eef2ff", // Light blue bg
            iconColor: "#4f46e5", // Indigo/Blue
        },
        {
            id: 2,
            icon: <FaUserTie />,
            title: "Expert Assisted Filing",
            description:
                "Dedicated CAs and CSs handle your filings so you can focus on growing your business.",
            iconBg: "#eff6ff",
            iconColor: "#3b82f6",
        },
        {
            id: 3,
            icon: <GoBell />,
            title: "Deadline Tracking & Alerts",
            description:
                "Never miss a due date with proactive reminders for every compliance deadline.",
            iconBg: "#f0f9ff",
            iconColor: "#0ea5e9",
        },
    ];

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>Why Businesses <span style={{color:"var(--PrimaryColor)"}}>Choose Us</span></h2>
                <p className={styles.subtitle}>
                    Built for reliability, designed for simplicity
                </p>
            </div>

            <div className={styles.grid}>
                {features.map((feature) => (
                    <div key={feature.id} className={styles.card}>
                        <div
                            className={styles.iconWrapper}
                        // style={{ backgroundColor: feature.iconBg, color: feature.iconColor }}
                        >
                            {feature.icon}
                        </div>
                        <h3 className={styles.cardTitle}>{feature.title}</h3>
                        <p className={styles.cardDescription}>{feature.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WhyChooseUs;
